import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { UnitDataFormTypes } from 'modules/Shared/State/unit';
import { IdentifiersContainer } from 'modules/UnitOverview/UnitInformation/Components/IdentifiersContainer';

import { useMarineIdentifiersSectionValidation } from '../Validations';
import { IdentifiersMarineFields } from './IdentifiersMarineFields';

export const IdentifiersMarineSection = () => {
	const { control, trigger } = useFormContext<UnitDataFormTypes>();
	const { t } = useTranslation('unitCreation');

	const isValidSection = useMarineIdentifiersSectionValidation({
		control,
		trigger,
	});

	return (
		<IdentifiersContainer
			title={t('unit-information-identifiers-title')}
			subtitle={
				<Typography
					variant="body2"
					color={isValidSection ? 'unset' : 'error.main'}>
					{t('unit-information-identifiers-description')}
				</Typography>
			}
			isValidSection={isValidSection}
			showAsterisk>
			<IdentifiersMarineFields />
		</IdentifiersContainer>
	);
};
